var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 8.5C14.2068 8.5 12.9669 9.01361 12.0526 9.92785C11.1384 10.8421 10.6248 12.0821 10.6248 13.375V15.9761L9.58043 18.5912C9.54772 18.6734 9.53561 18.7623 9.54516 18.8502C9.5547 18.938 9.58561 19.0223 9.63519 19.0954C9.68477 19.1686 9.75151 19.2286 9.82959 19.27C9.90766 19.3115 9.9947 19.3332 10.0831 19.3333H13.3331C13.3331 20.5337 14.2994 21.5 15.4998 21.5C16.7001 21.5 17.6664 20.5337 17.6664 19.3333H20.9164C21.0048 19.3332 21.0919 19.3115 21.1699 19.27C21.248 19.2286 21.3148 19.1686 21.3643 19.0954C21.4139 19.0223 21.4448 18.938 21.4544 18.8502C21.4639 18.7623 21.4518 18.6734 21.4191 18.5912L20.3748 15.975V13.375C20.3748 12.0821 19.8612 10.8421 18.9469 9.92785C18.0327 9.01361 16.7927 8.5 15.4998 8.5ZM16.5831 19.3333C16.5831 19.9357 16.1021 20.4167 15.4998 20.4167C14.8974 20.4167 14.4164 19.9357 14.4164 19.3333H16.5831ZM11.7081 13.375C11.7081 12.3694 12.1076 11.405 12.8187 10.6939C13.5297 9.98281 14.4942 9.58333 15.4998 9.58333C16.5054 9.58333 17.4698 9.98281 18.1809 10.6939C18.892 11.405 19.2914 12.3694 19.2914 13.375V16.0812C19.2916 16.1498 19.3048 16.2179 19.3304 16.2816L20.1169 18.25H10.8826L11.6691 16.2816C11.6947 16.2179 11.7079 16.1498 11.7081 16.0812V13.375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelAlerts);
export default __webpack_public_path__ + "static/media/panelAlerts.b3dba11680fa8187429e51fa554b3472.svg";
export { ForwardRef as ReactComponent };